import React from 'react';
/* eslint-disable */
export function Google(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none" {...props}>
      <path
        d="M11.2083 8.18184V12.0546H16.5901C16.3538 13.3001 15.6446 14.3546 14.581 15.0637L17.8265 17.5819C19.7174 15.8365 20.8083 13.2729 20.8083 10.2274C20.8083 9.51832 20.7447 8.83643 20.6265 8.18195L11.2083 8.18184Z"
        fill="#4285F4"
      />
      <path
        d="M5.60401 11.9034L4.87203 12.4637L2.28107 14.4819C3.92653 17.7455 7.29902 20.0001 11.2081 20.0001C13.9081 20.0001 16.1719 19.1092 17.8265 17.5819L14.581 15.0637C13.6901 15.6637 12.5535 16.0274 11.2081 16.0274C8.60811 16.0274 6.39907 14.2729 5.6081 11.9092L5.60401 11.9034Z"
        fill="#34A853"
      />
      <path
        d="M2.28108 5.51822C1.59929 6.86362 1.20842 8.38183 1.20842 10C1.20842 11.6182 1.59928 13.1365 2.28107 14.4819C2.28107 14.4909 5.60843 11.8999 5.60843 11.8999C5.40843 11.2999 5.29021 10.6636 5.29021 9.99989C5.29021 9.33617 5.40843 8.69984 5.60843 8.09984L2.28108 5.51822Z"
        fill="#FBBC05"
      />
      <path
        d="M11.2083 3.98184C12.6811 3.98184 13.9901 4.49092 15.0356 5.47276L17.8992 2.60914C16.1628 0.990977 13.9084 0 11.2083 0C7.29923 0 3.92654 2.24546 2.28108 5.51822L5.60843 8.09984C6.39929 5.73616 8.60831 3.98184 11.2083 3.98184Z"
        fill="#EA4335"
      />
    </svg>
  );
}
